import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTarhAsoodeh = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={35} height={34} fill='none' {...props}>
    <rect width={34} height={34} x={0.668} fill='#26C6DA' rx={8} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='m11.66 18.995-1.14-1.14a1.204 1.204 0 0 1 0-1.695l1.14-1.14c.196-.195.353-.577.353-.847V12.56c0-.66.54-1.2 1.2-1.2h1.613c.27 0 .652-.157.847-.352l1.14-1.14a1.204 1.204 0 0 1 1.695 0l1.14 1.14c.195.195.578.352.848.352h1.612c.66 0 1.2.54 1.2 1.2v1.613c0 .27.158.652.353.847l1.14 1.14c.465.465.465 1.23 0 1.695l-1.14 1.14a1.4 1.4 0 0 0-.353.848v1.612c0 .66-.54 1.2-1.2 1.2h-1.612c-.27 0-.653.158-.848.353l-1.14 1.14a1.204 1.204 0 0 1-1.695 0l-1.14-1.14a1.4 1.4 0 0 0-.847-.353h-1.613c-.66 0-1.2-.54-1.2-1.2v-1.612c0-.278-.157-.66-.352-.848M15.418 19.25l4.5-4.5M19.539 18.875h.007'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M15.789 15.125h.007'
    />
  </svg>
);
export default SvgTarhAsoodeh;
